export default __webpack_public_path__ + "static/media/lg1.46520525.jpg";